"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _setIn;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _count2 = _interopRequireDefault(require("./_count"));

var _has2 = _interopRequireDefault(require("./_has"));

var _get2 = _interopRequireDefault(require("./_get"));

var _keyedEquivalent2 = _interopRequireDefault(require("./_keyedEquivalent"));

var _reduce2 = _interopRequireDefault(require("./_reduce"));

var _set2 = _interopRequireDefault(require("./_set"));

function makeSetStack(keyPath, subject) {
  return (0, _reduce2.default)([], function (acc, key) {
    if (!acc.length) {
      acc.push([subject, key]);
      return acc;
    }

    var _acc = (0, _slicedToArray2.default)(acc[acc.length - 1], 2),
        prevValue = _acc[0],
        prevKey = _acc[1];

    var actualValue = (0, _get2.default)(prevKey, prevValue);
    var nextValue = actualValue === undefined && !(0, _has2.default)(prevKey, prevValue) ? (0, _keyedEquivalent2.default)(prevValue) : actualValue;
    acc.push([nextValue, key]);
    return acc;
  }, keyPath);
}

function _setIn(keyPath, value, subject) {
  if ((0, _count2.default)(keyPath) === 0) {
    return value;
  }

  var setStack = makeSetStack(keyPath, subject);
  var result = value;

  while (setStack.length > 0) {
    var _setStack$pop = setStack.pop(),
        _setStack$pop2 = (0, _slicedToArray2.default)(_setStack$pop, 2),
        layer = _setStack$pop2[0],
        key = _setStack$pop2[1];

    result = (0, _set2.default)(key, result, layer);
  }

  return result;
}

module.exports = exports.default;